define((require) => {
    "use strict";

    const DropAreaHotspot                       = require("ui/behaviors/DropAreaHotspot");
    const DetailedImageLibraryCollectionView    = require("ui/imageLibrary/DetailedImageLibraryCollectionView");
    const ProjectDashboardImageView             = require("ui/projects/image/ProjectDashboardImageView");

    /**
     * Subclass of <tt>DetailedImageLibraryCollectionView</tt> representing the Image Dashboard in a project context. <p>
     *
     * @class ProjectDashboardImageLibrary
     * @see DetailedImageLibraryCollectionView
     * @see ProjectDashboardImageView
     */
    return DetailedImageLibraryCollectionView.extend("ProjectDashboardImageLibrary", {

        itemView: ProjectDashboardImageView,

        behaviors: {
            dropAreaHotspot: {
                behaviorClass: DropAreaHotspot,
                message: "<h4>Add <br/>images to Project</h4><p> Drag from desktop or click to upload</p>",
                dropAreaSelector: ".collection",
                iconSize: "small"
            }
        },

        onUpload({descriptors}) {
            this.__super();

            const {project} = this.options;

            descriptors.forEach((imageUploadDescriptor) => {
                imageUploadDescriptor.promise.then(() => {
                    project.attach(imageUploadDescriptor.model);
                });
            });
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/image/ProjectDashboardImageLibrary.js